export const industries = [
    {
        slug: "hotels",
        name: "Hotels",
        summary: "Bath linens, bedding, F&B and housekeeping supplies for 3- to 7-star hotels.",
        image: "https://images.unsplash.com/photo-1621293954908-907159247fc8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxob3RlbCUyMGludGVyaW9yJTIwbHV4dXJ5JTIwbG9iYnl8ZW58MHx8fHwxNzgzNjg2NTU3fDA&ixlib=rb-4.1.0&q=85",
        productPath: "/products/towels",
        productLabel: "Explore hotel textiles",
    },
    {
        slug: "hospitals",
        name: "Hospitals",
        summary: "Ward linens, scrubs, uniforms, and PPE for hospital and clinical procurement.",
        image: "https://images.unsplash.com/photo-1648224394432-8830fec15349?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob3NwaXRhbCUyMHdhcmQlMjBzdGVyaWxlfGVufDB8fHx8MTc4MzY4NjU1Nnww&ixlib=rb-4.1.0&q=85",
        productPath: "/products/home-textiles",
        productLabel: "View hospital textiles",
    },
    {
        slug: "hospitality",
        name: "Hospitality",
        summary: "Restaurants, resorts, cruise and spa supply chains with lead-time-critical schedules.",
        image: "https://images.unsplash.com/photo-1590490360182-c33d57733427?w=1200",
        productPath: "/products/towels",
        productLabel: "See hospitality-ready sourcing",
    },
    {
        slug: "government",
        name: "Government",
        summary: "Tender-backed programs for defence, police, railway, and municipal buyers.",
        image: "https://images.unsplash.com/photo-1541872703-74c5e44368f9?w=1200",
        productPath: "/products/safety-products",
        productLabel: "Review government supply programs",
    },
    {
        slug: "corporate",
        name: "Corporate",
        summary: "Corporate uniforms, gifting, and workwear for global multi-site rollouts.",
        image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200",
        productPath: "/products/uniform-fabrics",
        productLabel: "Explore corporate apparel sourcing",
    },
    {
        slug: "schools",
        name: "Schools",
        summary: "Uniform fabric, ready uniforms, and school-linked textile programs.",
        image: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=1200",
        productPath: "/products/uniform-fabrics",
        productLabel: "View school uniform programs",
    },
    {
        slug: "construction",
        name: "Construction",
        summary: "Coveralls, hi-viz, helmets, harnesses and site-safety programs.",
        image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1200",
        productPath: "/products/safety-products",
        productLabel: "See safety gear solutions",
    },
    {
        slug: "manufacturing",
        name: "Manufacturing",
        summary: "Industrial workwear, gloves, and safety programs for factory-floor buyers.",
        image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=1200",
        productPath: "/products/safety-products",
        productLabel: "Review industrial PPE programs",
    },
    {
        slug: "retail",
        name: "Retail",
        summary: "Private-label programs for supermarkets, department stores and e-commerce.",
        image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1200",
        productPath: "/products/home-textiles",
        productLabel: "Explore retail-ready textiles",
    },
    {
        slug: "wholesale",
        name: "Wholesale",
        summary: "Import wholesalers, cash-and-carry, and buying-house programs.",
        image: "https://images.unsplash.com/photo-1553413077-190dd305871c?w=1200",
        productPath: "/products/towels",
        productLabel: "See wholesale export options",
    },
    {
        slug: "agriculture",
        name: "Agriculture",
        summary: "Farm-to-container programs for rice, spices, pulses and fresh produce.",
        image: "https://images.unsplash.com/photo-1500595046743-cd271d694d30?w=1200",
        productPath: "/products/agro-products",
        productLabel: "Browse agro export products",
    },
];
